module.exports = __webpack_public_path__ + "ef54f7440b4b4d946955c84677b0e6d9.svg";